import { WISE, APM } from '@/views/checkout/payment/helper/constant';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import store from '@/store';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { planTypes } from '@/common/constants';

export const apmPaymentType = (paymentMethodName = '', imageFileName) => {
  if (paymentMethodName === WISE) {
    const wisePaymentName = getWisePaymentName(imageFileName);
    return `apm-${wisePaymentName}`;
  }
  return `apm-${paymentMethodName}`;
};

export const getWisePaymentName = (imageFileName) => {
  const wiseSubstr = `${WISE}-`;
  return imageFileName.substring(imageFileName.indexOf(wiseSubstr) + wiseSubstr.length).toLowerCase();
};

export const getApmGaTrackingName = (paymentMethodName, imageFileName) => {
  if (paymentMethodName === WISE) {
    return imageFileName.replace(WISE, APM).toLowerCase();
  }
  return `${APM}-${paymentMethodName}`.toLowerCase();
};

export const checkIfPaidToPaidFlow = (currentFlowType) => {
  const { planType, oldPlanCode } = pageConfig.editConfig;
  const { boughtPlans, getSelectedPlans } = store.getters;
  const currentSelectedPlan = getSelectedPlans.find((item) => item.type === planType);
  const currentBoughtPlan = boughtPlans.find((item) => item.plan_code === oldPlanCode);
  const isZoBasicPlusUpgrade =
    currentSelectedPlan && currentBoughtPlan
      ? getPlanTypeByCategory(currentSelectedPlan?.category) === planTypes.ZOOM_MEETING &&
        getPlanTypeByCategory(currentBoughtPlan?.category) === planTypes.ZONE_BASIC_PLUS
      : false;
  return (
    [flowTypes.edit, flowTypes.add2cart, flowTypes.pro2biz, flowTypes.downgrade].includes(currentFlowType) ||
    (currentFlowType === flowTypes.upgrade &&
      !!isZoBasicPlusUpgrade) /* when the flow type is upgrade, only from zobasicplus to meeting plan is the P2P flow*/
  );
};
